import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './PageDesign/Styles/GlobalStyle.css'
import "bootstrap/dist/css/bootstrap.min.css";
import reportWebVitals from './reportWebVitals';
import Landing from './PageDesign/LandingPageRoute';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const Router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <title>Empresas | Yo Me Controlo</title>
        <Landing />
      </>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <RouterProvider router={Router} />
);

reportWebVitals();